import { render, staticRenderFns } from "./bugInfo.vue?vue&type=template&id=dae4907c&scoped=true"
import script from "./bugInfo.vue?vue&type=script&lang=js"
export * from "./bugInfo.vue?vue&type=script&lang=js"
import style0 from "./bugInfo.vue?vue&type=style&index=0&id=dae4907c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae4907c",
  null
  
)

export default component.exports